import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import { getStorage } from "firebase/storage";
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, onAuthStateChanged, signInAnonymously } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getDatabase } from "firebase/database";

const firebaseSolarConfig = {
  apiKey: "AIzaSyBBMil1BaQc3FOlDhFglJEEIVgMueYN_Ik",
  authDomain: "emas-solar.firebaseapp.com",
  projectId: "emas-solar",
  storageBucket: "emas-solar.firebasestorage.app",
  messagingSenderId: "325185389819",
  appId: "1:325185389819:web:e73da2e57844dce7735c5e",
  measurementId: "G-7G262X0N6E"
};
const appSolar = initializeApp(firebaseSolarConfig, "solar");

export const authSolar = getAuth(appSolar);
export const dbSolar = getFirestore(appSolar)
export const methodsSolar = {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut
}

export const storageSolar = getStorage(appSolar, appSolar.storageBucket);
// export const database = getDatabase();


// Initialize Firebase




export default appSolar